import { render } from "./company-personnel-results-count.vue?vue&type=template&id=4ebcff59&scoped=true"
import script from "./company-personnel-results-count.vue?vue&type=script&lang=js"
export * from "./company-personnel-results-count.vue?vue&type=script&lang=js"

import "./company-personnel-results-count.vue?vue&type=style&index=0&id=4ebcff59&scoped=scoped&lang=less"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ebcff59"]])

export default __exports__